import i18next from "i18next";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateAll = (quantity: IQuantity, actions: any) => {
  const t = i18next.getFixedT(null, "admin");
  switch (quantity) {
    case Quantity.NONE:
      return [];
    case Quantity.ONE:
      return [
        {
          key: "see",
          text: t("orders.commandBar.see"),
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanel,
        },
      ];
    case Quantity.MANY:
      return [];
  }
};
